import type { RequestFn } from '../client';

export class Forex {
  constructor(private readonly request: RequestFn) {}

  /** Retrieve forex rates. `GET /forex/rates` */
  async getRates(
    params?: Record<string, string | number | undefined>,
  ): Promise<Record<string, unknown>> {
    return this.request('GET', '/forex/rates', { query: params });
  }

  /** Convert from minor currency. `GET /forex/convert-from-minor` */
  async convertFromMinor(
    params: Record<string, string | number | undefined>,
  ): Promise<Record<string, unknown>> {
    return this.request('GET', '/forex/convert-from-minor', { query: params });
  }
}
